import { render, staticRenderFns } from "./ElectionBook.vue?vue&type=template&id=2cd5ba54&"
import script from "./ElectionBook.vue?vue&type=script&lang=js&"
export * from "./ElectionBook.vue?vue&type=script&lang=js&"
import style0 from "./ElectionBook.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports